var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@/common';
import ConfigurationNameModal from '@/common/confirmation-modal';
import Header from '@/common/header';
import SidePanel from '@/common/side-panel';
import { useMutation } from '@/hoc/hooks/useMutation';
import { useQuery } from '@/hoc/hooks/useQuery';
import { BackIcon, EncryptDataIcon, SearchIcon } from '@/icons';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useUpdateContext } from '@/contextProvider/context.provider';
import DataBaseFolder from './database-folder';
var MetaDataSelection = function () {
    var _a, _b;
    var _c = useState({
        id: false,
        username: false,
        password: false,
        login_date: false,
    }), checkedColumns = _c[0], setCheckedColumns = _c[1];
    var _d = useState([]), columns = _d[0], setColumns = _d[1];
    var _e = useState(''), searchTerm = _e[0], setSearchTerm = _e[1];
    var _f = useState(true), sidePanelOpen = _f[0], setSidePanelOpen = _f[1];
    var navigate = useNavigate();
    var _g = useState([]), databaseData = _g[0], setDatabaseData = _g[1];
    var _h = useState([]), metaDataSelection = _h[0], setMetaDataSelection = _h[1];
    var _j = useState({}), selectedCollections = _j[0], setSelectedCollections = _j[1];
    var _k = useState({}), collectionFieldsData = _k[0], setCollectionFieldsData = _k[1];
    // Use the update context
    var _l = useUpdateContext(), updateRowData = _l.updateRowData, isUpdateMode = _l.isUpdateMode, clearUpdateData = _l.clearUpdateData;
    var apiResponse = useQuery('/metadata').data;
    var handleCheckboxChange = function (data) {
        var _a, _b;
        // Update metaDataSelection state
        var updatedMetaDataSelection = metaDataSelection.map(function (item) {
            return item.field === data.field ? __assign(__assign({}, item), { isEncrypted: !item.isEncrypted }) : item;
        });
        setMetaDataSelection(updatedMetaDataSelection);
        // Update the specific collection's field data in collectionFieldsData
        if (databaseInfo.collection) {
            setCollectionFieldsData(function (prev) {
                var _a;
                var currentCollectionData = prev[databaseInfo.collection] || [];
                var updatedCollectionData = currentCollectionData.map(function (item) {
                    return item.field === data.field ? __assign(__assign({}, item), { isEncrypted: !item.isEncrypted }) : item;
                });
                return __assign(__assign({}, prev), (_a = {}, _a[databaseInfo.collection] = updatedCollectionData, _a));
            });
            // Update selected collections based on encryption state
            var currentDbName_1 = (_b = (_a = databaseInfo === null || databaseInfo === void 0 ? void 0 : databaseInfo.dbDetails) === null || _a === void 0 ? void 0 : _a.dbDetails) === null || _b === void 0 ? void 0 : _b.database;
            if (currentDbName_1) {
                var hasAnyEncryptedFields_1 = updatedMetaDataSelection.some(function (field) { return field.isEncrypted; });
                setSelectedCollections(function (prev) {
                    var _a, _b;
                    var currentSelections = prev[currentDbName_1] || [];
                    if (hasAnyEncryptedFields_1) {
                        // Add collection to selected if it has any encrypted fields and isn't already selected
                        if (!currentSelections.includes(databaseInfo.collection)) {
                            return __assign(__assign({}, prev), (_a = {}, _a[currentDbName_1] = __spreadArray(__spreadArray([], currentSelections, true), [databaseInfo.collection], false), _a));
                        }
                    }
                    else {
                        // Remove collection from selected if no fields are encrypted
                        return __assign(__assign({}, prev), (_b = {}, _b[currentDbName_1] = currentSelections.filter(function (col) { return col !== databaseInfo.collection; }), _b));
                    }
                    return prev;
                });
            }
        }
    };
    var handleClearAll = function () {
        var _a, _b;
        var cleared = metaDataSelection.map(function (field) { return (__assign(__assign({}, field), { 
            // Only clear isEncrypted if the field is not disabled
            isEncrypted: field.isDisable ? field.isEncrypted : false })); });
        setMetaDataSelection(cleared);
        // Update the specific collection's field data in collectionFieldsData
        if (databaseInfo.collection) {
            setCollectionFieldsData(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[databaseInfo.collection] = cleared, _a)));
            });
            // Remove collection from selected collections since all non-disabled fields are now unencrypted
            var currentDbName_2 = (_b = (_a = databaseInfo === null || databaseInfo === void 0 ? void 0 : databaseInfo.dbDetails) === null || _a === void 0 ? void 0 : _a.dbDetails) === null || _b === void 0 ? void 0 : _b.database;
            if (currentDbName_2) {
                setSelectedCollections(function (prev) {
                    var _a;
                    var currentSelections = prev[currentDbName_2] || [];
                    return __assign(__assign({}, prev), (_a = {}, _a[currentDbName_2] = currentSelections.filter(function (col) { return col !== databaseInfo.collection; }), _a));
                });
            }
        }
    };
    var _m = useState(false), isMobile = _m[0], setIsMobile = _m[1];
    var _o = useState([]), collection = _o[0], setCollection = _o[1];
    var _p = useState({}), databaseInfo = _p[0], setDatabaseInfo = _p[1];
    var _q = useState([]), allMetaData = _q[0], setAllMetaData = _q[1];
    var _r = useMutation(), trigger = _r.trigger, configData = _r.data, configLoading = _r.loading, configError = _r.error;
    var handleSelectAllEncrypted = function (isChecked) {
        var _a, _b;
        var updated = metaDataSelection.map(function (item) { return (__assign(__assign({}, item), { 
            // Only update isEncrypted if the field is not disabled
            isEncrypted: item.isDisable ? item.isEncrypted : isChecked })); });
        setMetaDataSelection(updated);
        // Update the specific collection's field data in collectionFieldsData
        if (databaseInfo.collection) {
            setCollectionFieldsData(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[databaseInfo.collection] = updated, _a)));
            });
            // Update collection selection based on encryption state
            var currentDbName_3 = (_b = (_a = databaseInfo === null || databaseInfo === void 0 ? void 0 : databaseInfo.dbDetails) === null || _a === void 0 ? void 0 : _a.dbDetails) === null || _b === void 0 ? void 0 : _b.database;
            if (currentDbName_3) {
                setSelectedCollections(function (prev) {
                    var _a, _b;
                    var currentSelections = prev[currentDbName_3] || [];
                    if (isChecked) {
                        // Add collection to selected if not already present
                        if (!currentSelections.includes(databaseInfo.collection)) {
                            return __assign(__assign({}, prev), (_a = {}, _a[currentDbName_3] = __spreadArray(__spreadArray([], currentSelections, true), [databaseInfo.collection], false), _a));
                        }
                    }
                    else {
                        // Remove collection from selected
                        return __assign(__assign({}, prev), (_b = {}, _b[currentDbName_3] = currentSelections.filter(function (col) { return col !== databaseInfo.collection; }), _b));
                    }
                    return prev;
                });
            }
        }
    };
    useEffect(function () {
        var checkIfMobile = function () {
            setIsMobile(window.innerWidth < 768);
            if (window.innerWidth < 768) {
                setSidePanelOpen(false);
            }
        };
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return function () { return window.removeEventListener('resize', checkIfMobile); };
    }, []);
    var _s = useState(false), showModal = _s[0], setShowModal = _s[1];
    var handleSave = function (name) {
        var _a, _b, _c;
        var currentDbName = (_b = (_a = databaseInfo === null || databaseInfo === void 0 ? void 0 : databaseInfo.dbDetails) === null || _a === void 0 ? void 0 : _a.dbDetails) === null || _b === void 0 ? void 0 : _b.database;
        var currentCollection = databaseInfo === null || databaseInfo === void 0 ? void 0 : databaseInfo.collection;
        var selectedCollectionsForDb = selectedCollections[currentDbName] || [];
        var tablePayload = {};
        if (selectedCollectionsForDb.length === 0) {
            tablePayload = {};
        }
        else {
            // Build the payload structure for specific collections
            selectedCollectionsForDb.forEach(function (collectionName) {
                var collectionFields = [];
                // CRITICAL FIX: Always use the current metaDataSelection for the active collection
                if (collectionName === currentCollection) {
                    collectionFields = __spreadArray([], metaDataSelection, true); // Use current state
                }
                else {
                    // For other collections, use stored data
                    collectionFields = collectionFieldsData[collectionName] || [];
                }
                var encryptedFields = collectionFields.filter(function (field) { return field.isEncrypted === true; });
                if (encryptedFields.length === 0) {
                    tablePayload[collectionName] = {};
                }
                else if (encryptedFields.length === collectionFields.length &&
                    collectionFields.length > 0) {
                    tablePayload[collectionName] = {
                        all: true,
                    };
                }
                else {
                    tablePayload[collectionName] = {
                        fields: encryptedFields.map(function (field) {
                            if (!field.isDisable) {
                                return {
                                    field: field.field,
                                    type: field.type,
                                    isEncrypted: field.isEncrypted,
                                    tooltipMsg: field.tooltipMsg || '',
                                };
                            }
                        }),
                    };
                }
            });
        }
        // Determine HTTP method and endpoint based on update mode
        var httpMethod = isUpdateMode ? 'PUT' : 'POST';
        var endpoint = '/metadatadbdetails';
        // Build payload - include ID for PUT requests
        var payload = {
            configName: name,
            databaseId: (_c = databaseInfo === null || databaseInfo === void 0 ? void 0 : databaseInfo.dbDetails) === null || _c === void 0 ? void 0 : _c._id,
            DBName: currentDbName,
            table: tablePayload,
        };
        // Add ID for PUT requests if available
        if (isUpdateMode && (updateRowData === null || updateRowData === void 0 ? void 0 : updateRowData._id)) {
            payload.id = updateRowData === null || updateRowData === void 0 ? void 0 : updateRowData._id;
        }
        setShowModal(false);
        trigger(endpoint, httpMethod, payload)
            .then(function (res) {
            var successMessage = isUpdateMode
                ? 'Configuration updated successfully!'
                : 'Configuration saved successfully!';
            toast.success(successMessage);
            if (isUpdateMode) {
                clearUpdateData();
            }
            navigate('/configured-list');
        })
            .catch(function (err) {
            console.error('Error:', err);
            var errorMessage = isUpdateMode
                ? 'Failed to update configuration'
                : 'Failed to save configuration';
            toast.error(err.message || errorMessage);
        });
    };
    useEffect(function () {
        if (apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.data) {
            setDatabaseData(apiResponse.data);
            setAllMetaData(apiResponse.data);
        }
    }, [apiResponse]);
    useEffect(function () {
        if (collection && collection.length > 0) {
            // Show ALL fields, preserve their original isEncrypted values
            var formattedCollection_1 = collection.map(function (field) { return ({
                field: field.field || '',
                type: field.type || 'unknown',
                isEncrypted: Boolean(field.isEncrypted), // Keep original isEncrypted value (true/false)
                isDisable: field.isDisable,
                tooltipMsg: field.tooltipMsg || '',
            }); });
            var columnsData = ['Field Name', 'Data Type', 'Encrypt Data'];
            setColumns(columnsData);
            setMetaDataSelection(formattedCollection_1);
            // Store the collection data for the current collection
            if (databaseInfo.collection) {
                setCollectionFieldsData(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a[databaseInfo.collection] = formattedCollection_1, _a)));
                });
            }
        }
        else {
            console.log('No collection data available');
            setColumns([]);
            setMetaDataSelection([]);
        }
    }, [collection, databaseInfo.collection]);
    // Update the useEffect that switches between collections to use collectionFieldsData
    useEffect(function () {
        if (databaseInfo.collection && collectionFieldsData[databaseInfo.collection]) {
            var collectionData = collectionFieldsData[databaseInfo.collection];
            setMetaDataSelection(__spreadArray([], collectionData, true)); // Create a new array to trigger re-render
        }
    }, [databaseInfo.collection, collectionFieldsData]);
    // Filter rows based on search term - this should show ALL fields
    var filteredRows = useMemo(function () {
        var filtered = metaDataSelection.filter(function (data) {
            return data.field.toLowerCase().includes(searchTerm.toLowerCase()) ||
                data.type.toLowerCase().includes(searchTerm.toLowerCase());
        });
        return filtered;
    }, [metaDataSelection, searchTerm]);
    var allEncryptedChecked = useMemo(function () {
        // Filter out disabled fields first
        var enabledFields = filteredRows.filter(function (row) { return !row.isDisable; });
        // If there are no enabled fields, return false
        if (enabledFields.length === 0)
            return false;
        // Check if all enabled fields are encrypted
        return enabledFields.every(function (row) { return row.isEncrypted === true; });
    }, [filteredRows]);
    // Function to handle collection selection from DataBaseFolder
    var handleCollectionSelection = function (collectionName, fields) {
        var _a, _b;
        // Keep ALL fields with their original isEncrypted values
        var isAll = (_b = (_a = updateRowData === null || updateRowData === void 0 ? void 0 : updateRowData.table) === null || _a === void 0 ? void 0 : _a[collectionName]) === null || _b === void 0 ? void 0 : _b.all;
        var formattedFields = [];
        if (isAll) {
            formattedFields = fields.map(function (field) { return ({
                field: field.field || '',
                type: field.type || 'unknown',
                isEncrypted: true, // Preserve original boolean value
                isDisable: field.isDisable,
                tooltipMsg: field.tooltipMsg || '',
            }); });
        }
        else {
            formattedFields = fields.map(function (field) { return ({
                field: field.field || '',
                type: field.type || 'unknown',
                isEncrypted: Boolean(field.isEncrypted), // Preserve original boolean value
                isDisable: field.isDisable,
                tooltipMsg: field.tooltipMsg || '',
            }); });
        }
        setCollection(formattedFields);
        // Store the fields for this collection
        setCollectionFieldsData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[collectionName] = formattedFields, _a)));
        });
    };
    // FIXED: Handle collection checkbox change (when clicking on collection checkbox in sidebar)
    var handleCollectionCheckboxChange = function (dbName, collectionName, isChecked) {
        // Initialize collection fields data if it doesn't exist
        var initializeCollectionIfNeeded = function () {
            if (!collectionFieldsData[collectionName]) {
                // Get the raw data from API response for this collection
                var rawCollectionData = databaseData.find(function (db) { var _a; return ((_a = db === null || db === void 0 ? void 0 : db.dbDetails) === null || _a === void 0 ? void 0 : _a.database) === dbName; });
                var apiResponseData = allMetaData;
                if (apiResponseData && apiResponseData[collectionName]) {
                    var initialFields_1 = apiResponseData[collectionName].map(function (field) { return ({
                        field: field.field,
                        type: field.type || 'string',
                        isEncrypted: false,
                        isDisable: field.isDisable,
                        tooltipMsg: field.tooltipMsg || '',
                    }); });
                    setCollectionFieldsData(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[collectionName] = initialFields_1, _a)));
                    });
                    return initialFields_1;
                }
            }
            return collectionFieldsData[collectionName] || [];
        };
        // First, update selected collections
        setSelectedCollections(function (prev) {
            var _a, _b;
            var currentSelections = prev[dbName] || [];
            if (isChecked) {
                return currentSelections.includes(collectionName)
                    ? prev
                    : __assign(__assign({}, prev), (_a = {}, _a[dbName] = __spreadArray(__spreadArray([], currentSelections, true), [collectionName], false), _a));
            }
            else {
                return __assign(__assign({}, prev), (_b = {}, _b[dbName] = currentSelections.filter(function (col) { return col !== collectionName; }), _b));
            }
        });
        // Handle field encryption state changes
        if (isChecked) {
            // When checking a collection checkbox, encrypt ALL non-disabled fields of that collection
            var fieldsToUpdate_1 = initializeCollectionIfNeeded();
            if (databaseInfo.collection === collectionName) {
                // If this collection is currently being viewed, update the current view
                var updatedFields_1 = metaDataSelection.map(function (field) { return (__assign(__assign({}, field), { 
                    // Encrypt ALL fields (both disabled and non-disabled will be set to true)
                    isEncrypted: field.isDisable ? field.isEncrypted : true })); });
                setMetaDataSelection(updatedFields_1);
                // Update stored collection data
                setCollectionFieldsData(function (prevFields) {
                    var _a;
                    return (__assign(__assign({}, prevFields), (_a = {}, _a[collectionName] = updatedFields_1, _a)));
                });
            }
            else {
                // Update stored collection data for non-current collection
                setCollectionFieldsData(function (prevFields) {
                    var _a;
                    var existingFields = prevFields[collectionName] || fieldsToUpdate_1;
                    var updatedFields = existingFields.map(function (field) { return (__assign(__assign({}, field), { 
                        // Encrypt ALL fields
                        isEncrypted: field.isDisable ? field.isEncrypted : true })); });
                    return __assign(__assign({}, prevFields), (_a = {}, _a[collectionName] = updatedFields, _a));
                });
            }
        }
        else {
            // When unchecking a collection checkbox, decrypt ALL non-disabled fields of that collection
            var fieldsToUpdate_2 = initializeCollectionIfNeeded();
            if (databaseInfo.collection === collectionName) {
                // If this collection is currently being viewed, update the current view
                var updatedFields_2 = metaDataSelection.map(function (field) { return (__assign(__assign({}, field), { 
                    // Decrypt ALL non-disabled fields
                    isEncrypted: field.isDisable ? field.isEncrypted : false })); });
                setMetaDataSelection(updatedFields_2);
                // Update stored collection data
                setCollectionFieldsData(function (prevFields) {
                    var _a;
                    return (__assign(__assign({}, prevFields), (_a = {}, _a[collectionName] = updatedFields_2, _a)));
                });
            }
            else {
                // Update stored collection data for non-current collection
                setCollectionFieldsData(function (prevFields) {
                    var _a;
                    var existingFields = prevFields[collectionName] || fieldsToUpdate_2;
                    var updatedFields = existingFields.map(function (field) { return (__assign(__assign({}, field), { 
                        // Decrypt ALL non-disabled fields
                        isEncrypted: field.isDisable ? field.isEncrypted : false })); });
                    return __assign(__assign({}, prevFields), (_a = {}, _a[collectionName] = updatedFields, _a));
                });
            }
        }
    };
    // Update page title based on update mode
    var pageTitle = isUpdateMode ? 'Update Metadata Configuration' : 'Metadata Selection';
    var buttonLabel = isUpdateMode ? 'Update Configuration' : 'Encrypt Data';
    return (_jsxs("div", { className: 'flex min-h-screen bg-gray-50', children: [_jsx(SidePanel, { open: !isMobile && sidePanelOpen, onMenuClick: isMobile ? undefined : function () { return setSidePanelOpen(function (prev) { return !prev; }); }, isMobile: isMobile }), _jsx("div", { className: "flex-1 transition-all duration-300", style: {
                    width: isMobile
                        ? 'calc(100% - 4rem)'
                        : sidePanelOpen
                            ? 'calc(100% - 16rem)'
                            : 'calc(100% - 4rem)',
                }, children: _jsxs("div", { className: 'p-2 md:p-2 w-full', children: [_jsx(Header, {}), _jsxs("div", { className: 'flex items-center mb-6', children: [_jsx("div", { onClick: function () { return navigate(-1); }, className: 'cursor-pointer flex items-center', children: _jsx(BackIcon, {}) }), _jsx("h1", { className: 'text-2xl font-semibold text-gray-800 ml-2', children: pageTitle }), isUpdateMode && (_jsx("span", { className: 'ml-3 px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded-full', children: "Update Mode" }))] }), _jsxs("div", { className: 'bg-white p-4 md:p-6 rounded-xl shadow min-h-screen overflow-x-auto', children: [_jsxs("div", { className: 'flex flex-col md:flex-row md:justify-between md:items-center mb-6 gap-4', children: [_jsx("h1", { className: 'text-2xl font-bold text-gray-800', children: (_b = (_a = databaseInfo.collection) !== null && _a !== void 0 ? _a : databaseInfo.dbName) !== null && _b !== void 0 ? _b : '' }), _jsxs("div", { className: 'flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full md:w-auto', children: [_jsxs("div", { className: 'flex items-center bg-[#f5f3f7] border border-[#e5e5ea] rounded-lg px-3 py-2 w-full sm:w-80', children: [_jsx(SearchIcon, {}), _jsx("input", { type: 'text', placeholder: 'Search...', className: 'bg-transparent focus:outline-none text-[#4b4369] placeholder-[#4b4369] w-full ml-2', value: searchTerm, onChange: function (e) { return setSearchTerm(e.target.value); } })] }), _jsxs("div", { className: 'flex gap-2', children: [_jsx(Button, { label: 'Clear All', className: 'min-w-[120px] px-4 py-2 rounded-lg border border-[#6C63FF] text-blue-800 bg-violet-100 hover:bg-[#e6e1ff] text-sm font-medium cursor-pointer', onClick: handleClearAll }), _jsx(Button, { label: buttonLabel, icon: _jsx(EncryptDataIcon, {}), className: "flex items-center justify-center min-w-[140px] px-4 py-2 rounded-lg text-sm font-medium cursor-pointer ".concat(isUpdateMode
                                                                ? 'bg-green-600 hover:bg-green-700 text-white'
                                                                : 'bg-blue-700 hover:bg-blue-800 text-white'), onClick: function () { return setShowModal(true); } }), _jsx(ConfigurationNameModal, { isOpen: showModal, onClose: function () { return setShowModal(false); }, onSave: handleSave, configName: isUpdateMode ? updateRowData === null || updateRowData === void 0 ? void 0 : updateRowData.configName : '' })] })] })] }), _jsxs("div", { className: 'flex flex-row gap-3', children: [_jsx("div", { className: 'w-64 bg-white border rounded-md shadow-md h-screen p-2 space-y-2 overflow-y-auto', children: (databaseData === null || databaseData === void 0 ? void 0 : databaseData.length) > 0 &&
                                                (databaseData === null || databaseData === void 0 ? void 0 : databaseData.map(function (db, index) { return (_jsx(DataBaseFolder, { setDatabaseInfo: setDatabaseInfo, dbData: db, setCollection: setCollection, databaseInfo: databaseInfo, selectedCollections: selectedCollections, setSelectedCollections: setSelectedCollections, onCollectionSelection: handleCollectionSelection, setAllMetaData: setAllMetaData, collectionFieldsData: collectionFieldsData, onCollectionCheckboxChange: handleCollectionCheckboxChange }, index)); })) }), _jsx("div", { className: 'overflow-x-auto rounded-lg w-full', children: _jsxs("table", { className: 'min-w-full bg-white', children: [_jsx("thead", { className: 'bg-gray-50', children: _jsx("tr", { children: columns.map(function (column, i) { return (_jsx("th", { className: 'px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider', children: _jsx("div", { className: 'flex items-center justify-between', children: column === 'Encrypt Data' ? (_jsxs("div", { className: 'flex items-center gap-2', children: [_jsx("input", { type: 'checkbox', checked: allEncryptedChecked, onChange: function (e) { return handleSelectAllEncrypted(e.target.checked); }, className: 'h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded' }), _jsx("span", { children: column })] })) : (column) }) }, i)); }) }) }), _jsx("tbody", { className: 'divide-y divide-gray-200', children: filteredRows.length > 0 ? (filteredRows.map(function (data, index) { return (_jsxs("tr", { className: index % 2 === 0 ? 'bg-white' : 'bg-gray-50', children: [_jsx("td", { className: 'px-6 py-4 whitespace-nowrap text-sm text-gray-700', children: data.field }), _jsx("td", { className: 'px-6 py-4 whitespace-nowrap text-sm text-gray-700', children: data.type }), _jsx("td", { className: 'relative px-6 py-4 whitespace-nowrap text-sm text-gray-700 group', children: _jsxs("div", { className: 'flex items-center', children: [_jsx("input", { disabled: data.isDisable, checked: Boolean(data.isEncrypted), onChange: function () { return handleCheckboxChange(data); }, type: 'checkbox', className: 'h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded' }), data.isDisable && (_jsx("div", { className: 'absolute left-6 top-1/2 -translate-y-1/2 ml-2 bg-gray-800 text-white text-xs rounded px-2 py-1 shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10', children: data.tooltipMsg || 'This field is disabled' }))] }) })] }, "".concat(data.field, "-").concat(index))); })) : (_jsx("tr", { children: _jsx("td", { colSpan: columns.length, className: 'px-6 py-8 text-center text-gray-500 text-xl', children: metaDataSelection.length === 0
                                                                    ? 'No data available. Please select a collection.'
                                                                    : 'No fields match your search.' }) })) })] }) })] })] })] }) })] }));
};
export default MetaDataSelection;
